var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.5V4.81175C15 4.75255 14.9884 4.69392 14.9658 4.63922C14.9431 4.58453 14.9099 4.53484 14.868 4.493L12.507 2.132C12.4227 2.04758 12.3083 2.00011 12.189 2H3.45C3.33065 2 3.21619 2.04741 3.1318 2.1318C3.04741 2.21619 3 2.33065 3 2.45V16.55C3 16.6693 3.04741 16.7838 3.1318 16.8682C3.21619 16.9526 3.33065 17 3.45 17H8.25M6 8H12M6 5H9M6 11H8.25M15.375 15.875L16.5 17",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2V4.55C12 4.66935 12.0474 4.78381 12.1318 4.8682C12.2162 4.95259 12.3307 5 12.45 5H15M11.25 14C11.25 14.5967 11.4871 15.169 11.909 15.591C12.331 16.0129 12.9033 16.25 13.5 16.25C14.0967 16.25 14.669 16.0129 15.091 15.591C15.5129 15.169 15.75 14.5967 15.75 14C15.75 13.4033 15.5129 12.831 15.091 12.409C14.669 11.9871 14.0967 11.75 13.5 11.75C12.9033 11.75 12.331 11.9871 11.909 12.409C11.4871 12.831 11.25 13.4033 11.25 14Z",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc6);
export default __webpack_public_path__ + "static/media/ic-6.61639c342b6f13a7e072a8d138dd0ffb.svg";
export { ForwardRef as ReactComponent };